/**
 * Make an array from an array.
 *
 * @param lis
 * @param low1
 * @param u1
 * @param low2
 * @param u2
 * @template T The inner type of the array
 * @return {Array<Array<T>>} The sectioned array.
 */
export function make_array_of_array(lis, low1, u1, low2, u2) {
    const result = [];
    for (let u = low1; u < u1; ++u) {
        const toAdd = [];
        for (let v = low2; v < u2; ++v) {
            toAdd.push(lis[v][u]);
        }
        result.push(toAdd);
    }
    return result;
}
/**
 * Slice a list into a new array.
 *
 * @param list The initial list
 * @param lower The lower bound (inclusive)
 * @param upper The upper bound (exclusive)
 * @template T The inner type of the array
 * @return The sliced array.
 */
export function list_to_array(list, lower, upper) {
    return list.slice(lower, upper);
}
/**
 *
 *
 * @param name The unit name
 * @return The matching exponents
 */
export function dimensions_for_si_unit(name) {
    throw new Error('Function not implemented.');
}
/**
 *
 * @param orientation
 * @param items
 * @template T The inner type of the array
 * @return The conditionally reversed array
 */
export function conditional_reverse(orientation, items) {
    return orientation ? items : [...items].reverse();
}
/**
 *
 * @param arg0
 */
export function get_basis_surface(arg0) {
    throw new Error('Function not implemented.');
}
/**
 * Choose between two values based on the value of a boolean. (ife)
 *
 * @param orientation
 * @param fromTrue
 * @param fromFalse
 * @template T The inner type of the array
 * @return The chosen value
 */
export function boolean_choose(orientation, fromTrue, fromFalse) {
    return orientation ? fromTrue : fromFalse;
}
/**
 *
 * @param ref_direction
 */
export function build_2axes(ref_direction) {
    throw new Error('Function not implemented.');
}
/**
 *
 * @param axis
 * @param ref_direction
 */
export function build_axes(axis, ref_direction) {
    throw new Error('Function not implemented.');
}
/**
 *
 * @param arg0
 */
export function is_sql_mappable(arg0) {
    throw new Error('Function not implemented.');
}
/**
 *
 * @param arg0
 */
export function is_int_expr(arg0) {
    throw new Error('Function not implemented.');
}
/**
 *
 * @param base
 */
export function representation_of_link(base) {
    throw new Error('Function not implemented.');
}
/**
 *
 * @param arg0
 */
export function get_name_value(arg0) {
    throw new Error('Function not implemented.');
}
/**
 * Get the express ID of a particular entity
 *
 * @param arg0 The element to extract the express ID from
 * @return The express id or "inline" for inline elements
 */
export function get_id_value(arg0) {
    return arg0.expressID?.toString() ?? 'inline';
}
/**
 *
 * @param arg0
 */
export function get_description_value(arg0) {
    throw new Error('Function not implemented.');
}
/**
 *
 * @param arg0
 */
export function get_multi_language(arg0) {
    throw new Error('Function not implemented.');
}
/**
 *
 * @param unit
 */
export function derive_dimensional_exponents(unit) {
    throw new Error('Function not implemented.');
}
/**
 * Get the dimension of an entity.
 *
 * @param arg0 The object to get the dimension of
 * @throws {Error} Not implemented.
 */
export function dimension_of(arg0) {
    throw new Error('Function not implemented.');
}
/**
 * Get the role from an entity.
 *
 * @param arg0 The object to get the role from
 * @throws {Error} Not implemented.
 */
export function get_role(arg0) {
    throw new Error('Function not implemented.');
}
